import type { SxProps, Theme } from "@mui/material/styles";

import type { StatusBadgeColor } from "@/components/Atoms/StatusBadge/StatusBadge.types";

const dotColorMap: Record<StatusBadgeColor, (theme: Theme) => string> = {
  error: (theme) => theme.palette.error.main,
  warning: (theme) => theme.palette.warning.main,
  info: (theme) => theme.palette.info.main,
  success: (theme) => theme.palette.success.main,
  neutral: (theme) => theme.palette.text.secondary,
};

export const root: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(0, 1fr)) auto",
  alignItems: "center",
  gap: theme.spacing(1.5),
  py: theme.spacing(1.5),
  px: theme.spacing(1),
  borderBottom: 1,
  borderColor: "divider",

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1),
  },
});

export const field: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  minWidth: 0,
});

export const fieldText: SxProps<Theme> = {
  color: "text.primary",
  fontWeight: 500,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const statusColumn: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  justifyContent: "flex-start",
});

export const statusDot =
  (color: StatusBadgeColor): SxProps<Theme> =>
  (theme) => ({
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0,
    backgroundColor: dotColorMap[color](theme),
  });

export const statusLabel: SxProps<Theme> = {
  color: "text.secondary",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

export const badgeWrap: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-start",
};
